// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3tUW4","row":"ProcedureTreatmentSummary_row__FV2op"};